(()=>{
 if(customElements.get('sw-pasta-motion'))return;
 customElements.define('sw-pasta-motion',class extends HTMLElement{
  connectedCallback(){
   if(this._connected)return;
   this._connected=true;
   this._repeat=this.hasAttribute('data-sw-pasta-motion-repeat');
   if(this._stopped||(!this._repeat&&this._used))return;
   this._abort=new AbortController();
   this._reduce=matchMedia('(prefers-reduced-motion: reduce)');
   this._eligible=false;
   const roots=[document.documentElement,document.body];
   const off=()=>this._reduce.matches||roots.some(n=>n.dataset.swPastaMotion==='off'||n.classList.contains('vp_filter_stop_animations'));
   const images=Array.from(this.querySelectorAll('img'));
   const ready=()=>images.every(img=>img.complete&&img.naturalWidth>0);
   const stop=()=>{this._stopped=true;this._cleanup();};
   const sync=()=>{
    if(this._stopped)return;
    if(off()||document.hidden||!this._eligible||!ready()){
     if(!this._repeat&&this._used){stop();return;}
     this._pause();return;
    }
    if(this._playing||(!this._repeat&&this._used))return;
    this._playing=true;
    if(!this._repeat)this._used=true;
    this.setAttribute('data-sw-pasta-motion-running','');
    if(!this._repeat)this._timer=setTimeout(stop,4600);
   };
   images.forEach(img=>img.addEventListener('load',sync,{signal:this._abort.signal}));
   this._onReduce=sync;
   this._reduce.addEventListener?.('change',this._onReduce);
   this._mutation=new MutationObserver(sync);
   for(const node of roots)this._mutation.observe(node,{attributes:true,attributeFilter:['class','style','data-sw-pasta-motion']});
   document.addEventListener('visibilitychange',sync,{signal:this._abort.signal});
   document.addEventListener('sw-pasta-motion-stop',stop,{signal:this._abort.signal});
   document.addEventListener('click',e=>{
    const b=e.target.closest?.('button,[role="button"]');
    if(!b||b.id==='_vp_act_stop_animations')return;
    const label=((b.getAttribute('aria-label')||'')+' '+b.textContent).normalize('NFD').replace(/[\u0591-\u05C7]/g,'');
    if(/עצירת תנועה|הפסקת תנועה|עצור אנימציות|הפסק אנימציות|ביטול אנימציות|stop animations|disable animations|pause animations/i.test(label))stop();
   },{capture:true,signal:this._abort.signal});
   if(!('IntersectionObserver'in window)){stop();return;}
   this._intersection=new IntersectionObserver(entries=>{
    for(const e of entries){this._eligible=e.isIntersecting&&e.intersectionRatio>=.5;sync();}
   },{threshold:[0,.5]});
   this._intersection.observe(this);
  }
  disconnectedCallback(){this._connected=false;this._cleanup();}
  _pause(){this.removeAttribute('data-sw-pasta-motion-running');this._playing=false;clearTimeout(this._timer);this._timer=null;}
  _cleanup(){
   this._pause();
   this._intersection?.disconnect();this._intersection=null;
   this._mutation?.disconnect();this._mutation=null;
   this._abort?.abort();this._abort=null;
   this._reduce?.removeEventListener?.('change',this._onReduce);
  }
 });
})();
